import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
document.addEventListener('DOMContentLoaded', () => [...document.querySelectorAll('.js-assignment-form-app')]
    .map((e) => {
    var _a, _b, _c;
    return ({
        root: ReactDOM.createRoot(e),
        volunteerApiUri: (_a = e.getAttribute('data-volunteer-api-uri')) !== null && _a !== void 0 ? _a : '',
        volunteerAppSecret: (_b = e.getAttribute('data-volunteer-app-secret')) !== null && _b !== void 0 ? _b : '',
        labels: JSON.parse((_c = e.getAttribute('data-labels')) !== null && _c !== void 0 ? _c : '{}'),
    });
})
    .filter(({ volunteerApiUri, volunteerAppSecret }) => volunteerApiUri.length > 0 && volunteerAppSecret.length > 0)
    .forEach(({ root, volunteerApiUri, volunteerAppSecret, labels }) => {
    root.render(_jsx(React.StrictMode, { children: _jsx(App, { volunteerApiUri: volunteerApiUri, volunteerAppSecret: volunteerAppSecret, labels: labels }) }));
}));
